const SECTION_PADDING_VALUE = 'clamp(32px, 6vw, 96px)';

export const sectionSpacingStyles = {
  paddingTop: SECTION_PADDING_VALUE,
  paddingBottom: SECTION_PADDING_VALUE,
};

export const sectionSpacingCss = `
  padding-top: ${SECTION_PADDING_VALUE};
  padding-bottom: ${SECTION_PADDING_VALUE};
`;
